<app-navbar></app-navbar>
<ng-content></ng-content>
<app-footer></app-footer>
